export const eventsActionTypes = {
    SET_EVENTS: 'SET_EVENTS',
    SETAPI_EVENTS: 'SETAPI_EVENTS'
};